import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import i18n from 'i18next';
import { css } from '@emotion/core';
import { updateShowPasswordQualifyStatus } from 'client/redux/modules/promoState';

import useLogout from 'client/hooks/logout/useLogout';
import {
    closeSystemErrorDialog,
    handlers,
    showErrDialog
} from 'client/redux/modules/systemErrorDialog';
import DialogSystemLoading from 'client/components/DialogSystemLoading';
import useSearchParams from 'hooks/useSearchParams';

function DialogSystemError() {
    const logout = useLogout();
    const history = useHistory();
    const searchParams = useSearchParams();

    const dispatch = useDispatch();
    const systemErrorDialog = useSelector(s => s.systemErrorDialog);
    const { persist, show, title, desc, handler } = systemErrorDialog;

    const DEFAULT_COOL_DOWN_SEC = 0;
    // [860t32w1m] 修正系統繁忙中的處理和訊息提示 handlers.RELOAD 與 handlers.TRY_AGAIN 基本上功能一樣，差在說明、按鈕文字、按鈕在點擊一次時有冷卻時間
    const HIGH_TRAFFIC_COOL_DOWN_SEC = 6;

    const [onClick, endButton, waitingTime] = (() => {
        switch (handler) {
            case handlers.CLOSE:
                return [
                    () => dispatch(closeSystemErrorDialog()),
                    i18n.t('btn.close'),
                    DEFAULT_COOL_DOWN_SEC
                ];
            case handlers.PASSCODE_DENIED:
                return [
                    () => {
                        dispatch(closeSystemErrorDialog());
                        if (searchParams.get('pcode')) {
                            searchParams.delete('pcode');
                            history.replace({ search: searchParams.toString() });
                        }
                        window.location.reload();
                    },
                    i18n.t('btn.reload'),
                    DEFAULT_COOL_DOWN_SEC
                ];
            case handlers.PASSCODE_UNVERIFIED:
                return [
                    () => {
                        dispatch(closeSystemErrorDialog());
                        dispatch(
                            updateShowPasswordQualifyStatus({
                                hasUsablePasscode: false,
                                passcode: '',
                                passcodeRemainingCount: 0
                            })
                        );
                    },
                    i18n.t('btn.close'),
                    DEFAULT_COOL_DOWN_SEC
                ];
            case handlers.RELOAD:
                return [
                    () => window.location.reload(),
                    i18n.t('btn.reload'),
                    DEFAULT_COOL_DOWN_SEC
                ];
            case handlers.TRY_AGAIN:
                return [
                    () => window.location.reload(),
                    i18n.t('btn.try_again'),
                    HIGH_TRAFFIC_COOL_DOWN_SEC
                ];
            case handlers.LOGOUT_RELOAD:
                return [() => logout(), i18n.t('btn.relogin'), DEFAULT_COOL_DOWN_SEC];
            case handlers.HIDE_BUTTON:
            default:
                return [() => {}, null, DEFAULT_COOL_DOWN_SEC];
        }
    })();

    return (
        <>
            <DialogSystemLoading
                isOpen={show}
                title={title}
                body={desc}
                closePopup={onClick}
                endButton={endButton}
                waitingTime={waitingTime}
            />
            {persist && <div css={fullWrapperStyle} onClick={() => dispatch(showErrDialog())} />}
        </>
    );
}

export default DialogSystemError;

const fullWrapperStyle = css`
    position: absolute;
    right: 0;
    left: 0;
    top: 0;
    bottom: 0;
    z-index: 10;
`;
